import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { ChevronDownIcon } from '../../../../../assets/icons/index';
import { PaginationController } from '../../../../../components/pagination-controller/index';
import {
  Select,
  SelectButton,
  SelectOption,
  SelectOptions,
} from '../../../../../components/select/index';
import { itemsToFetchMap } from '../../../variables';

export type PaginationItemProps = {
  currentPage: number;
  handleChangeCurrentPage: (page: number) => void;
  handleFetchAmountChange: (items: number) => void;
  itemsToFetch: number;
  totalPages: number;
};

export const PaginationItem: FC<PaginationItemProps> = ({
  handleFetchAmountChange,
  itemsToFetch,
  currentPage,
  handleChangeCurrentPage,
  totalPages,
}) => {
  if (currentPage < 1) return null;
  if (currentPage > totalPages) return null;
  // Single page fits every row — hide the items-per-page selector; only show it from two pages up.
  if (totalPages <= 1) return null;

  return (
    <div className="flex w-full items-center justify-between p-4">
      <Select
        onChange={(fetchItems) => handleFetchAmountChange(fetchItems as unknown as number)}
        value={itemsToFetch as unknown as string}
      >
        {({ open }) => (
          <div className="relative rounded border-gray-200">
            <SelectButton className="flex items-center gap-4 bg-gray-25 py-[10px] pl-[12px] pr-[6px]">
              <span className="text-m font-[450] text-gray-700">{itemsToFetch}</span>
              <ChevronDownIcon
                className={twMerge(
                  'h-[13px] w-[13px] transition-transform duration-200',
                  open && 'rotate-180',
                )}
              />
            </SelectButton>
            <SelectOptions
              className={twMerge(
                'absolute left-0 right-0 top-[-6px] mt-1 max-h-60 w-[58px] -translate-y-full transform overflow-auto rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none',
              )}
            >
              {itemsToFetchMap.map((select) => (
                <SelectOption key={select} value={select as unknown as string}>
                  <span className="block text-m font-normal text-gray-700">{select}</span>
                </SelectOption>
              ))}
            </SelectOptions>
          </div>
        )}
      </Select>

      <PaginationController
        className="shrink-0"
        currentPage={currentPage}
        onClick={handleChangeCurrentPage}
        totalPages={totalPages}
      />
    </div>
  );
};
